import { createAction, props } from '@ngrx/store';
import { Sesion } from './session.interface';

export const GUARDAR_SESION = createAction(
  '[Auth] Auth Session',
  props<{ sesion: Sesion }>()
);

export const GUARDAR_MEDIO_ENVIO = createAction(
  '[Medio Envio] Guardar Medio Envio',
  props<{ medio_envio_codigo: string; numero_envio_codigo: string }>()
);

export const GUARDAR_MENSAJE = createAction(
  '[Mensaje] Guardar Mensaje',
  props<{ mensaje: string }>()
);
export const GUARDAR_EMAIL = createAction(
  '[Email] Guardar Email',
  props<{ email: string }>()
);

export const GUARDAR_PANTALLA = createAction(
  '[Pantalla] Guardar Pantalla',
  props<{ pantalla: string }>()
);

export const SET_RECHAZO = createAction(
  '[Auth] Set Rechazo',
  props<{
    sesion: Omit<Sesion, 'numero_envio_codigo' | 'medio_envio_codigo'>;
  }>()
);
